export class Testimonial {
    Name:string;
    Email:string;
    PhoneNo:string;
    VisitingDate:Date;
    Message:string;
    Captcha:string='';
}
